import { Center, Loader } from "@mantine/core";
import PreviewHeader from "components/header/PreviewHeader";
import AdminCreditJournalPreview from "pages/admin/dataEntry/AdminCreditJournalPreview";
import { useSearchParams } from "react-router-dom";

const PrintCrJnl: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  if (!id)
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  return (
    <div className="inner-container">
      <PreviewHeader />

      <AdminCreditJournalPreview id={Number(id)} />
    </div>
  );
};

export default PrintCrJnl;
